import { render, staticRenderFns } from "./Weekend.vue?vue&type=template&id=e2059ba0&scoped=true&"
import script from "./Weekend.vue?vue&type=script&lang=js&"
export * from "./Weekend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2059ba0",
  null
  
)

export default component.exports